import React from 'react';
import './style.css';

const Header = () => {
    return (
        <header>
            <h1>Screen it</h1>
        </header>
    )
}

export default Header;